import { render, staticRenderFns } from "./ExamFeeRequest.vue?vue&type=template&id=dc780870"
import script from "./ExamFeeRequest.vue?vue&type=script&lang=js"
export * from "./ExamFeeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports